import CheckboxInput, { SIZES } from './CheckboxInput';

export default CheckboxInput;
export { SIZES };
